import { getAxiosInstance } from "../ApiConfig";

async function FetchAllNotes(page, user) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/notes/${page}/${user}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchAllNotesbyduration(page, duration) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/selectedAllByDuration/${page}/${duration}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function NotesDetailData(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/notes/${id}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function UserNotes() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/UserNotes`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function deleteNoteId(id) {
    try {
        const data = await getAxiosInstance().delete(`/usermgmt/notes/${id}`);
        return data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function NoteSave(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/saveNotes`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function NoteUpdate(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/notes/${id}`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
export {
    FetchAllNotes,
    FetchAllNotesbyduration,
    NotesDetailData,
    deleteNoteId,
    NoteSave,
    NoteUpdate,
    UserNotes,
}